const AR = /[\u0600-\u06FF]/;
const LATIN_RUN = /([A-Za-z0-9+#@][A-Za-z0-9+#@_.,:/\- ]*[A-Za-z0-9_]|[A-Za-z0-9])/g;

// Arabic lines read right-to-left; brand names, numbers, phone numbers and hashtags inside them stay in one piece.
function Line({ line }) {
  if (!AR.test(line)) return <div dir="ltr" className="min-h-[1.25em] text-start">{line}</div>;
  return (
    <div dir="rtl" className="min-h-[1.25em] text-start">
      {line.split(LATIN_RUN).map((part, i) => (i % 2 ? <bdi key={i} dir="ltr">{part}</bdi> : part))}
    </div>
  );
}

export default function CaptionText({ text, className = "", testId }) {
  return (
    <div className={`text-sm ${className}`} data-testid={testId}>
      {String(text || "").split("\n").map((line, i) => <Line key={i} line={line} />)}
    </div>
  );
}
